export default __webpack_public_path__ + "static/media/LogoGreeners.d137bfdf.jpg";